module.exports = __webpack_public_path__ + "static/media/gallery (5).ad0954c9.jpg";